import React, {useCallback} from 'react';

export const useContainerCoords = ({containerRef}) => {
    const getXY = useCallback((e, useScroll=true) => {
        let scale = window._scale || 1;
        if (!containerRef || !containerRef.current) {
            return {x: 0, y: 0};
        }
        let el = containerRef.current.getBoundingClientRect();
        let scrollLeft = useScroll ? containerRef.current.scrollLeft : 0;
        let scrollTop = useScroll ? containerRef.current.scrollTop : 0;

        let coords = {
            x: e.clientX - el.left + scrollLeft,
            y: e.clientY - el.top + scrollTop
        };
        return coords;
    }, []);
    return {getXY};
};

